import React from "react";
import { COMPANY_SETTINGS } from "@/configs";
import UserSettings from "./user-settings";
import LangPicker from "./lang-picker";
import "./index.less";

type IPageHeaderProps = {
  /** 是否显示语言选择入口。 */
  showLang?: boolean;
};

/** 展示当前品牌标识、语言入口和用户设置的页面顶部导航。 */
const PageHeader: React.FC<IPageHeaderProps> = ({ showLang = true }) => {
  return (
    <div className="section page-header">
      <div className="header-left">
        {COMPANY_SETTINGS?.logo && <img src={COMPANY_SETTINGS?.logoText} alt={COMPANY_SETTINGS?.title} />}
        {/* <span>{COMPANY_SETTINGS?.title}</span> */}
        {/* <span>APEXMOVE</span> */}
      </div>
      <div className="header-right">
        {showLang && <LangPicker />}
        <UserSettings />
      </div>
    </div>
  );
};

export default PageHeader;
